var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightCornerMediumBgInverted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 51,
    viewBox: "0 0 75 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11266_38887",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 174,
    height: 51
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 173.067,
    y: 51,
    width: 173.067,
    height: 50.1726,
    transform: "rotate(180 173.067 51)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11266_38887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.499 25.8464L73.3579 25.8464L73.3579 0.55315L48.499 0.553155L48.499 25.8464Z",
    fill: "#CC5E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6331 51.1397L48.499 51.1396L48.499 25.8464L23.6331 51.1397Z",
    fill: "#992C21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6331 25.8464L48.499 25.8464L48.499 0.546011L23.6331 25.8464Z",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6333 0.546011L-1.22563 0.546015L-1.22563 25.8464L23.6333 0.546011Z",
    fill: "#9E7E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.499 51.1396L48.499 25.8464L23.6331 25.8464L48.499 51.1396Z",
    fill: "#BD3728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.22563 25.8464L23.6333 25.8464L23.6333 0.546011L-1.22563 25.8464Z",
    fill: "#C59A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3579 51.1397L98.2168 51.1396L98.2168 25.8464L73.3579 51.1397Z",
    fill: "#06B395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2168 25.8464L73.3579 25.8464L73.3579 51.1397L98.2168 25.8464Z",
    fill: "#049078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0659 38.4894L23.6329 51.1397L23.6329 25.8464L36.0659 38.4894Z",
    fill: "#CC5D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.499 51.1397L73.3579 51.1396L73.3579 25.8464L48.499 25.8464L48.499 51.1397Z",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1414 40.5952C64.8513 40.5952 62.9948 42.4842 62.9948 44.8143C62.9948 47.1445 64.8513 49.0334 67.1414 49.0334C69.4316 49.0334 71.2881 47.1445 71.2881 44.8143C71.2881 42.4842 69.4316 40.5952 67.1414 40.5952Z",
    fill: "#377FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1414 27.9456C64.8513 27.9456 62.9948 29.8345 62.9948 32.1647C62.9948 34.4948 64.8513 36.3838 67.1414 36.3838C69.4316 36.3838 71.2881 34.4948 71.2881 32.1647C71.2881 29.8345 69.4316 27.9456 67.1414 27.9456Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7083 40.5952C52.4182 40.5952 50.5616 42.4842 50.5616 44.8143C50.5616 47.1445 52.4182 49.0334 54.7083 49.0334C56.9985 49.0334 58.855 47.1445 58.855 44.8143C58.855 42.4842 56.9985 40.5952 54.7083 40.5952Z",
    fill: "#E6EDF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7083 27.9456C52.4182 27.9456 50.5616 29.8345 50.5616 32.1647C50.5616 34.4948 52.4182 36.3838 54.7083 36.3838C56.9985 36.3838 58.855 34.4948 58.855 32.1647C58.855 29.8345 56.9985 27.9456 54.7083 27.9456Z",
    fill: "#377FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3579 25.8464L98.2168 25.8464L98.2168 19.5213L73.3579 19.5213L73.3579 25.8464Z",
    fill: "#C59A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3579 6.87085L98.2168 6.87085L98.2168 0.545743L73.3579 0.545748L73.3579 6.87085Z",
    fill: "#9E7E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3579 19.5212L98.2168 19.5212L98.2168 13.1961L73.3579 13.1961L73.3579 19.5212Z",
    fill: "#9E7E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3579 13.1958L98.2168 13.1958L98.2168 6.87069L73.3579 6.8707L73.3579 13.1958Z",
    fill: "#C59A2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9249 0.546013C54.0584 0.546014 48.492 6.20971 48.492 13.1962C48.492 20.1827 54.0584 25.8464 60.9249 25.8464C67.7915 25.8464 73.3579 20.1827 73.3579 13.1962C73.3579 6.20971 67.7915 0.546012 60.9249 0.546013Z",
    fill: "#F27544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9251 6.87103C57.4918 6.87103 54.7086 9.70288 54.7086 13.1961C54.7086 16.6894 57.4918 19.5212 60.9251 19.5212C64.3584 19.5212 67.1416 16.6894 67.1416 13.1961C67.1416 9.70288 64.3584 6.87103 60.9251 6.87103Z",
    fill: "#F9AB8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9962 25.8464L48.499 11.0902L48.499 0.546011L23.6331 25.8464L33.9962 25.8464Z",
    fill: "#0C4D91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1359 0.546013L23.6331 15.3022L23.6331 25.8464L48.499 0.546011L38.1359 0.546013Z",
    fill: "#2161AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6329 0.545559L23.6329 15.3018L38.1357 0.545556L23.6329 0.545559Z",
    fill: "#0C4D91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6332 -6.53628L23.6332 15.3018L45.0962 -6.53628L23.6332 -6.53628Z",
    fill: "#0C4D91"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCornerMediumBgInverted);
export default __webpack_public_path__ + "static/media/right_corner_medium_bg_inverted.b6b0f9e114414229a27323c907823e14.svg";
export { ForwardRef as ReactComponent };